export function TabsAttrs() {
  return {
    showLableInfo: [],
    attrs: {
      type: "",
      tabPosition: "top",
      stretch: false
    }
  };
}
